import InvoicePreviewFileUpload from './InvoicePreviewFileUpload';
import PropTypes from 'prop-types';
import InvoicePreviewFileDesktop from './InvoicePreviewFileDesktop';
import InvoicePreviewFileMobile from './InvoicePreviewFileMobile';

export default function InvoicePreviewFile(props) {
    const { compactMode, id, onUpload, onRemove, className } = props;

    const Preview = compactMode ? InvoicePreviewFileMobile : InvoicePreviewFileDesktop;

    if (id) {
        return <Preview id={id} onUpload={onUpload} className={className} />;
    }

    return <InvoicePreviewFileUpload compactMode={compactMode} onUpload={onUpload} onRemove={onRemove} />;
}

InvoicePreviewFile.propTypes = {
    compactMode: PropTypes.bool,
    id: PropTypes.string,
    onUpload: PropTypes.func,
    onRemove: PropTypes.func,
    className: PropTypes.string,
};
